export default "__VITE_ASSET__DuP4ARZ___"